import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Location } from '@angular/common';
import { DbAdminComponent } from '@luzula/luzula-lib';
import { Command, NavbarService } from '../navbar.service';

/**
 * Eigener top-level Menüpunkt „Datenbankverwaltung" (nur Entwickler, Route
 * `admin/databases`). Wrapper um die Library-{@link DbAdminComponent}; aktiviert
 * — wie die Benutzerverwaltung — den Navbar-Zurück-Befehl.
 *
 * Bewusst SEPARAT von der Benutzerverwaltung (User-Wunsch 2026-08-03): die
 * DB-Verwaltung ist ein reines Entwickler-Werkzeug (CouchDB-Admin über den
 * luzula-api-Gateway) und gehört nicht unter die Benutzer-Seite. Zugang regelt
 * `canAccessDatenbankverwaltung` (role-model.ts) — Single-Source für Route-Guard
 * und Navbar-Sichtbarkeit.
 */
@Component({
	selector: 'bp-db-admin-page',
	standalone: true,
	imports: [DbAdminComponent],
	// Viewport-basierte feste Hoehe (bpweb-Muster, vgl. alle-bohrpunkte): height:100%
	// greift hier NICHT, weil die Vorfahren-Kette (html/body) keine feste Hoehe hergibt
	// -> die ganze Seite scrollte. Mit fester Hoehe scrollt die Lib-Komponente intern
	// (Tab-Nav bleibt fix). --navbar-height (Fallback 0) beruecksichtigt die Navbar, falls da.
	template: '<lz-db-admin></lz-db-admin>',
	styles: [':host { display: block; height: calc(var(--vh, 100vh) - var(--navbar-height, 0px)); overflow-y: auto; }'],
})
export class DbAdminPageComponent implements OnInit, OnDestroy {
	private navbar = inject(NavbarService);
	private location = inject(Location);

	ngOnInit(): void {
		this.navbar.subscribe(Command.goBack, () => this.location.back());
	}

	ngOnDestroy(): void {
		this.navbar.unsubscribe(Command.goBack);
	}
}
